import { API } from 'src/services'
import { multiSelect } from 'src/common/selectors'
import swal from 'sweetalert2'
import {resetStateToDefault} from 'src/utils'

function defaultState () {
  return {
    loading: false,
    month: (new Date()).getMonth() + 1,
    year: (new Date()).getFullYear(),
    notLocked: [],
    locked: [],
    rejected: [],
    confirmed: [],
    employees: {selected: []},
    companies: {selected: []},
    employers: {selected: []},
    rejectObservation: ''
  }
}

const getters = {
  currentUserKind (state, getters, rootState) {
    if (['all', 'group'].includes(rootState.userInfo.roleGroup.kind)) {
      return 'rh'
    }
    return 'employee'
  }
}

const mutations = {
  ...multiSelect.mapMutations(['companies', 'employees', 'employers']),
  resetState (state, payload) {
    resetStateToDefault(state, defaultState())
  },
  loading (state, payload) {
    state.loading = Boolean(payload)
  },
  month (state, payload) {
    state.month = payload
  },
  year (state, payload) {
    state.year = payload
  },
  loadedData (state, payload) {
    // yeh, back (benson) left to the front the job of decide what is this locker fucking kind

    payload = payload
      .map(locker => {
        let kind

        if (locker.pretty_state && (['rh_denied', 'employee_denied'].includes(locker.pretty_state.state))) {
          kind = locker.pretty_state.state
        } else if (locker.locked) {
          kind = locker.pretty_state.state
        } else if (
          (
            (locker.rh_confirmation && locker.rh_confirmation.confirmation) ||
            (locker.employee_confirmation && locker.employee_confirmation.confirmation)
          ) && !locker.locked
        ) {
          kind = locker.rh_confirmation && locker.rh_confirmation.confirmation
            ? 'rh_confirmed'
            : 'employee_confirmed'
        } else {
          kind = 'not_locked'
        }

        return {
          kind,
          employee: locker.employee,
          year: locker.year,
          id: locker.id,
          locked: locker.locked,
          month: locker.month,
          lockedAt: locker.lockedAt,
          operations: locker.operations
        }
      })

    state.notLocked = payload.filter(i => i.kind === 'not_locked')
    state.locked = payload.filter(i => ['rh_unilateral', 'employee_unilateral', 'all_confirmed'].includes(i.kind))
    state.rejected = payload.filter(i => ['rh_denied', 'employee_denied'].includes(i.kind))
    state.confirmed = payload.filter(i => ['rh_confirmed', 'employee_confirmed'].includes(i.kind))
  }
}

const actions = {
  async loadData ({ commit, state }, {mode}) {
    commit('loading', true)
    try {
      const result = await API.twoWayLockerGetData.save(
        {month: state.month, year: state.year},
        {
          month: state.month,
          year: state.year,
          [mode]: state[mode].selected.map(i => i.id)
        }
      )

      commit('loadedData', result.data.success || 'fei')
    } catch (e) {}
    commit('loading', false)
  },
  async executeAction ({ dispatch, state }, {viewMode, applyTo = 'all', operation}) {
    if (
      !['notLocked', 'confirmed', 'rejected', 'locked'].includes(viewMode) ||
      !(applyTo === 'all' || typeof applyTo === 'object') ||
      !['lock', 'lockUnilateral', 'unlock', 'confirm', 'reject'].includes(operation)
    ) {
      throw new Error('invalid params given to execute action locker')
    }

    const params = {
      year: state.year,
      month: state.month
    }

    if (applyTo === 'all') {
      params.employees = state[viewMode].map(i => i.employee.id)
    } else {
      params.employees = [applyTo.id]
    }

    const r = await dispatch(operation, params)
    return r
  },
  async lockUnilateral ({ state }, {employees, year, month}) {
    try {
      const result = await API.unilateralLocker.save({
        year,
        month,
        kind: 'employee',
        ids: employees
      })
      swal({
        type: 'success',
        text: result.data.success || 'Travamento unilateral realizado com sucesso'
      })
    } catch (e) {
      swal({
        type: 'error',
        text: e?.data?.error ? e.data.error : 'Não foi possível travar unilateralmente'
      })
    }
  },
  async confirm ({ state }, {employees, year, month}) {
    try {
      const result = await API.twoWayLockerConfirmation.save({
        year,
        month,
        confirmation: true,
        observation: null,
        lockRequestId: null,
        kind: 'employee',
        ids: employees
      })
      swal({
        type: 'success',
        text: result.data.success || 'Travamento confirmado com sucesso'
      })
    } catch (e) {
      swal({
        type: 'error',
        text: e?.data?.error ? e.data.error : 'Não foi possível confirmar o travamento'
      })
    }
  },
  async reject ({ state }, {employees, year, month}) {
    try {
      const result = await API.twoWayLockerConfirmation.save({
        year,
        month,
        confirmation: false,
        observation: state.rejectObservation,
        lockRequestId: null,
        kind: 'employee',
        ids: employees
      })
      swal({
        type: 'success',
        text: result.data.success || 'Travamento rejeitado com sucesso'
      })
    } catch (e) {
      swal({
        type: 'error',
        text: e?.data?.error ? e.data.error : 'Não foi possível rejeitar o travamento'
      })
    }
  },
  async unlock ({ state }, {employees, month, year}) {
    try {
      const result = await API.unlocker.save({
        year,
        month,
        kind: 'employee',
        ids: employees
      })
      swal({
        type: 'success',
        text: result.data.success || 'Destravamento realizado com sucesso'
      })
    } catch (e) {
      swal({
        type: 'error',
        text: e?.data?.error ? e.data.error : 'Não foi possível destravar as folhas'
      })
    }
  },
  async lock ({ state }, {employees, month, year}) {
    try {
      const result = await API.twoWayLocker.save(
        {month, year},
        {
          year,
          month,
          startConfirmed: true,
          kind: 'employee',
          ids: employees
        }
      )
      swal({
        type: 'success',
        text: result.data.success || 'Confirmação realizada com sucesso'
      })
    } catch (e) {
      swal({
        type: 'error',
        text: e?.data?.error ? e.data.error : 'Não foi possível travar iniciar o travamento'
      })
    }
  }
}

export default {
  namespaced: true,
  state: defaultState(),
  getters,
  mutations,
  actions
}
